'use strict';

function countrySelector() {
    const $countriesSelector = $('.countries-selector'),
        $goButton = $('.go-button');

    $countriesSelector.on('change', function(e) {
        e.preventDefault();
    })
    .on('focus', e => {
        e.preventDefault();
        $goButton.show();
    });

    $goButton.on('click', e => {
        e.preventDefault();

        const countrySelected = $countriesSelector.find(':selected').text().toLowerCase();
        if (countrySelected == 'us' || countrySelected == 'united states') {
            return false;
        }

        const countryUrl = $countriesSelector.find(':selected').val();
        document.location.href = countryUrl;
    })
    .on("focusout", () => {
        $goButton.hide();
    });
}

export default { countrySelector };